<template>
<ScreenLayout>

    <div v-if="!profile">
        No profile found <v-btn @click="makeProfile">Make</v-btn>
    </div>


    <!-- Form -->

    <div class="pa-10 white ma-7 elevation-3" style="position:relative;xbackground-color:rgba(0,0,0,0.0)">

        <div class="heading mb-3">Your Personal Profile</div>
        <FormControl v-model="profile" :schema="profileSchema" />
    </div>

    <div slot="right">
        
    </div>

</ScreenLayout>
</template>

<script>
import ScreenLayout from '@/screens/ScreenLayout'
import Db from '@/data/Db'
import Db1 from '@/data/Db1'
import ConfirmIcon from '@/ui-elements/ConfirmIcon'
import ListList from '@/forms/lists/ListList'
import RouterHelpers from '@/helpers/RouterHelpers'
import FormControl from '@/forms/FormControl'

export default {
    name: 'DcPreferences',
    props: {
        i: String, //id of selected item
    },
    components: {ScreenLayout, ConfirmIcon, ListList, FormControl},
    data() {
        return {
            // selectedIndex: null,
 
            profile: null,

            profileSchema: {

                fields: [ 
                    {
                        name: 'name',
                        type: 'text',
                        label: 'Full Name',
                        validation: '',
                    },
                    {
                        name: 'use_fact_find',
                        type: 'radio',
                        label: 'Client Fact Find',
                        items: [{value: 'No', text: "Don't send one"}, {value: 'Yes', text: "Send my own"}]
                    },
                    {
                        name: 'fact_find',
                        type: 'file',
                        multiple: false,
                        label: 'Client Fact Find',
                        visible: '"[use_fact_find]" == "Yes"'
                    },
                    {
                        name: 'use_bank_statements',
                        type: 'radio',
                        label: 'Bankstatements.com.au',
                        items: [{value: 'No', text: "I don't use them"}, {value: 'Yes', text: "I have an account"}]
                    },
                    {
                        name: 'bank_statements',
                        type: 'link',
                        label: 'Bankstatements Link',
                        visible: '"[use_bank_statements]" == "Yes"'
                    },
                ]
            },

        }
    },
    computed:{

    },
    methods: {

        cgc(newVal) {
            console.log('prefs got new val of ', newVal)
        },
        save() {
            Db1.saveDocument(this.profile)
        },
        makeProfile() {
            this.profile = {
                _id: Db1.me().uid,
                _path: '/apps/dc/preferences'
            }
        },

        controlChanged(newVal) {
            console.log('new value passed right up is ', newVal)
        }



    },

    created() {    
        console.log(Db1.me().uid)

        Db1.fetchDocument('apps/dc/preferences',  Db1.me().uid).then(doc => {
            this.profile = doc
        })
    },

    beforeDestroy() {
        this.save()
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// Preferences.vue?969164dc